// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "InlineNotification-module--cds--assistive-text--ca47f";
export var cdsHideFeedback = "InlineNotification-module--cds--hide-feedback--be29c";
export var cdsShowFeedback = "InlineNotification-module--cds--show-feedback--9dbc9";
export var cdsSkeleton = "InlineNotification-module--cds--skeleton--646ef";
export var cdsVisuallyHidden = "InlineNotification-module--cds--visually-hidden--6aceb";
export var darkMode = "InlineNotification-module--darkMode--6f455";
export var notification = "InlineNotification-module--notification--1ce35";